module.exports = {
    SET_SPINBUTTON_VISIBILITY: 'UI-SET_SPINBUTTON_VISIBILITY',
    UI_BUTTON_PRESSED: 'UI-UI_BUTTON_PRESSED',
    INCREASE_BET: 'UI-INCREASE_BET',
    DECREASE_BET: 'UI-DECREASE_BET',
    BUTTON_CLOSE: 'UI-CLOSE',
    BUTTON_HOME: 'UI-HOME',
    ON_RESIZE: 'UI-ON_RESIZE',
    SET_DIMENSIONS: 'UI-SET_DIMENSIONS',
    SET_REPLAYURL: 'UI-SET_REPLAYURL',
    TOGGLE_DIMENSIONS: 'TOGGLE_DIMENSIONS',
    SET_POPUP_SCREEN: 'UI-SET_POPUP_SCREEN',
    SET_AUTOPLAY_RESTART: 'UI-SET_AUTOPLAY_RESTART:',
    SET_SPIN_RING_ANIMATION: 'UI-SET_SPIN_RING_ANIMATION:',
    POPUP_SCREENS: {
        SETTINGS_MENU: 'UI-POPUP_SCREENS_SETTINGS_MENU',
        BET: 'UI-POPUP_SCREENS_BET',
        AUTOPLAY: 'UI-POPUP_SCREENS_AUTOPLAY',
        AUTOPLAY_ADVANCED_OPEN: 'UI-POPUP_SCREENS_AUTOPLAY_ADVANCED_OPEN',
        AUTOPLAY_ADVANCED_CLOSE: 'UI-POPUP_SCREENS_AUTOPLAY_ADVANCED_CLOSE',
        AUTOPLAY_INCREASE_SPINS: 'UI-POPUP_SCREENS_AUTOPLAY_INCREASE_SPINS',
        AUTOPLAY_DECREASE_SPINS: 'UI-POPUP_SCREENS_AUTOPLAY_DECREASE_SPINS',
    }
}